import { useUnit } from 'effector-react'
import {
  $totalCountOfWebSiteList,
  $webSiteCurrent,
  $webSiteList,
  getWebSiteListFx,
} from 'src/pages/ib/adMaterials/webSitePages/model'

export const useWebPageList = () => {
  const loading = useUnit(getWebSiteListFx.pending)
  const webSiteList = useUnit($webSiteList)
  const totalCountOfItems = useUnit($totalCountOfWebSiteList)

  return { loading, webSiteList, totalCountOfItems }
}

export const useWebPageCurrent = () => useUnit($webSiteCurrent)
